export default "__VITE_ASSET__BU4asToO__"